import './index.scss';
import onChange from 'on-change';
import { createEl, appendChildren } from './modules/utils';
import Airplane from './modules/airplane';
import Views from './modules/views';
//import ISI from './modules/isi';
import content from './content.json';
import sizeWarn from './Views/popups/sized.cshtml';
import audio from './Views/audio.cshtml';

import Intro from './modules/intro';

import PathUpdate from './modules/PathUpdate';

import Popup from './modules/popup';

import { updateArray } from './assets/views/00_common/userActions';

import videojs from 'video.js';




localStorage.clear();



class App {
  constructor() {
    const state = {
      flow: 'intro', // <string> which part of the main user flow [intro, takeoff, flying, cta]
      views: content.views,
      view: null, // <string> which view is currently showing (/client/assets/views)
      popup: null, // we may have overlays like ISI, instructions, etc.
    };

    this.update = this.update.bind(this);
    
    this.state = onChange(state, this.update, {"isShallow": true}); // monitor state changes

    this.el = createEl('div', { className: 'app' });
    
    this.el_size_warn = createEl('div', { className: 'el_size_warn', innerHTML: sizeWarn });

    this.airplane = new Airplane(this.state);
    
   	this.intro = new Intro(this.state, this.airplane);
    
    this.hasOutro = false;
    
    let _this = this;
    
    /// put views/ popups into app_content to scale.
    this.el_content = createEl('div', { className: 'app_content' });
    this.views = new Views(this.state);
    this.popup = new Popup(this.state);
    
    this.el_content.appendChild(this.views.el);
    this.el_content.appendChild(this.popup.el);
    this.el_content.appendChild(this.intro.el);
   
    
    /// create the ISI
    //this.isi = new ISI(this.state);
    
    this.audio =  createEl('div', { className: 'vo_audio', innerHTML: audio });


    appendChildren(this.el, this.airplane.el, this.el_content, this.el_size_warn, this.audio);

	/// static method for audio/ tabbing, can be used for tracking	    
	this._path = PathUpdate.getInstance();	    

	/// resize event to scale views/popups
    this.resize = this.resize.bind(this);
	
    window.addEventListener('resize', this.resize);
    
    /// when the app loads, remove preloader, init the audio players,
    /// mute all, start the isi auto scroll, and set the scaling
	window.onload = function(){
		document.body.classList.remove('loading');
		_this._path.setAudioPlayer(_this.audio);
		_this._path.muteAll();
			
		_this.resize();  
		
		_this._path.update("Intro1");	

    }
    
  }





  /// method to update views and popups 
  /// listening to any change to state

    update(path, current, previous) {

        
     //  console.log(this);
        //console.log(`---> state changed: ${path}: ${previous} -> ${current}`);

        //console.log(`${current}`);



        if (current === "Menu" || current === "aboutPadcev" || current === "populationPost" || current === "populationCisplatin" || current === "dosingAdministration" || current === "takeoff" || current === "Settings" || current === "Summary" || current === "Contact" || current === "FlightInstructions") {


            var menu_items_track;

            switch (current) {
                case 'Menu':
                    menu_items_track = 'Menu';
                    break;
                case 'takeoff':
                    menu_items_track = 'Start';
                    break;
                case 'aboutPadcev':
                    menu_items_track = 'About_Padcev'; 
                      window.dataLayer.push({
                          event: "gtm.click",
                          eventLabel: "О ПРЕПАРАТЕ ПАДЦЕВ",
                      });
                    break;
                case 'populationPost':
                    menu_items_track = '301_Trial_Overview';
                     window.dataLayer.push({
                         event: "gtm.click",
                         eventLabel: "ОБЗОР ИССЛЕДОВАНИЯ EV-301",
                     });
                    break;

                case 'populationCisplatin':
                    menu_items_track = '301_Trial_Results'; 
                     window.dataLayer.push({
                         event: "gtm.click",
                         eventLabel: "РЕЗУЛЬТАТЫ ИССЛЕДОВАНИЯ EV-301",
                     });
                    break;
                case 'dosingAdministration':
                    menu_items_track = 'Dosing_Administration';
                     window.dataLayer.push({
                         event: "gtm.click",
                         eventLabel: "РЕЖИМ ДОЗИРОВАНИЯ И СПОСОБ ПРИМЕНЕНИЯ",
                     });
                    break;
                case 'Settings':
                    menu_items_track = 'Settings';
                    break;
                case 'Summary':
                    menu_items_track = 'Summary';
                    break;
                case 'Contact':
                    menu_items_track = 'PI';
                    break;
                case 'FlightInstructions':
                    menu_items_track = 'Information'; 
                    break;

               
            }

            //trackingVar
           //console.log(menu_items_track);
            updateArray(menu_items_track); 





          //  console.log(`${current}`);
        }




        if ((current == '1') || (current == '2') || (current == '3') || (current == '4')) {
            localStorage.setItem('data-num', current);
        }

 		

        if (current == "Menu") {
            document.querySelector(".cockpit_layer_menu").classList.add("cockpitActive");
        } else {
            document.querySelector(".cockpit_layer_menu").classList.remove("cockpitActive");
        }


        
     

        let outro1 = localStorage.getItem('tab_aboutPadcev');
        let outro2 = localStorage.getItem('tab_populationPost');
        let outro3 = localStorage.getItem('tab_populationCisplatin');
        let outro4 = localStorage.getItem('tab_dosingAdministration');

        let closeButton = localStorage.getItem('close');
      
	/// stop video whenever there is a change
	this._path.stopAllVideo();

	/// set tabbing/ cc and audio
	this._path.update(current);
    
    /// currently has the final screen, reset everything

        if (this.hasOutro) {
		//this.resetAll();



    }
        
    /// shop popup
    if (path === 'popup' && current) {
      this.togglePopup(true);
      this.popup.update(current);
    } else {
    	if(previous!='takeoff' && current!= 'flying'){ /// don't close popup on takeoff
			
			/// close popups always if there is no current popup
			this.togglePopup(); 
			this.popup.update();   	
    	}
    }
    
    /// hide everything but the popup when there is a popup

    if (path === 'popup') {
    
		const popupExists = current != null;
		this.airplane.setBeaconsVisible(!popupExists); 
		this.airplane.setControlsActive(!popupExists);      

		/// hide beacons
		if(this.state.view) {
			this.airplane.setBeaconsVisible(false);
		}      
    }
         

    

    /// update views
       
    
    if (path === 'view') {
    
     /// show the current view
      this.views.update(previous, current);
      this.airplane.progress.updateView(previous, current);
      
      
      if (current) {
      	/// mark this view as visisted

        const index = this.state.views.map(x => x.name).indexOf(current);
        this.state.views[index].visited = true;
      }
      /// view was closed, check if we're ready for outro


        
     // else if ((outro1 == "complete") && (outro2 == "complete") && (outro3 == "complete") && (outro4 == "complete")) {

      else if (closeButton == "true") {

         

          //if (closeButton == "true") {
              //console.log("outro triggered");
              //let outroState = localStorage.getItem('state');

              //if (outroState !== "outro") {
              //    this.state.popup = 'outro';
              //    localStorage.setItem('state', 'outro');

              //}

          //}

         

       


         
              //if(outroCheck.opacity == "1"){
              //    console.log("outro showing");  
              //}
          
        }



      //  else if (this.state.views.filter(view => view.visited && !view.menuOnly).length === this.state.views.filter(view => !view.menuOnly).length) {

        
      //    // this.state.popup = 'outro';
          
      //}

      if (current) {
      
      	/// hide beacons
        this.airplane.setBeaconsVisible(false);
        this.airplane.setControlsActive(false);
        
        /// updateHistory for the visited states in the popup menu
          this.popup.updateHistory(current);
         // console.log("history updated: " + localStorage.getItem('data-num'));

        
      } else if (!this.state.popup) {
      
      	/// no popup, no views- show flying

        this.airplane.setBeaconsVisible(true);
        this.airplane.setControlsActive(this.state.flow === 'flying');
      }

      this.airplane.onViewClose(previous);

    }
         
	if (path === 'flow') {
	
		/// change from takeoff/ flying
		this.airplane.updateFlow(previous, current);
		this.airplane.setControlsActive(current === 'flying');
		
		/// revisit button was clicked, go back to flying
		if (current == 'revisit'){

			this.resetAll();
			this.state.flow = 'flying';
		}    
	} 

    if (current == 'outro') { 
    	/// play the current out animation 
    	/// sets the CSS class and starts the lottie animations
    	this.popup.outroani();
        this.hasOutro = true;

       // this.state.flow = 'revisit';

       // localStorage.clear();
    	
    	/// body class hasOutro is primarily being used to set the glow
    	/// behind the screens on the final screens. Can be used for other 
    	/// reasons. This was to have one glow image behind all final screens
    	/// independent of scaling
        document.body.classList.add('hasOutro');
        
        }


      


    
    this.resize();
  }
  

	/// after we see the outro animation
	/// used to reset everything 
  
  resetAll(){
 //	this.state.views.map(view=>view.visited=false);
	//this.airplane.progress.resetAll();	/// reset the side navigation indicators
	//this.airplane.resetBeacons();  /// reset the beacons (checkmarks)
	//this.hasOutro = false;
	//this.popup.resetHistory();	/// reset the menu popup history
	document.body.classList.remove('hasOutro');
  }


	/// call this method to toggle any open popups
	/// hides the top level popups
  togglePopup(n) {
  	if (n) {
     	this.views.el.classList.add('hidden');
            this.popup.el.classList.remove('hidden');
            
            
  	} else {
            this.views.el.classList.remove('hidden');
    	this.popup.el.classList.add('hidden');
    	this.state.popup = null;
      }

      // document.getElementById("outro_btn_MedicalInfo").innerHTML =
      //     "ОБЩАЯ ХАРАКТЕРИСТИКА<br />ЛЕКАРСТВЕННОГО ПРЕПАРАТА";
     
  }
  
  
  
  
  /// scale all elements in .app_content
  
  resize () {
      
  		let scale = 1;
  		let scale_w = 1;
   		let scale_h = 1;
 		
 		let _container = document.querySelector('.app_content');
 		let _cW = _container.offsetWidth;
  		let _cH = _container.offsetHeight;

  		let contentHeight = 540;
		let contentWidth = 1040;

		if(contentHeight > _cH){
			scale_h = _cH / contentHeight;
		}
		if(contentWidth > _cW){
			scale_w = _cW / contentWidth;
		}	
		
		scale = Math.min(scale, scale_w, scale_h);			

      if (scale >= 4) {
         // console.log("scale 4");
          scale = 4; 		/// max scale is 400%
      }

    

		/// all immediate children divs within the .app_content element will be scaled

  		let elms = document.querySelectorAll('.app_content > div');
  		elms.forEach(function(el) {
  			el.style.transform = `scale(${scale})`;
  		});
  }  
  

  

  
  
  
}



//let buttons = document.querySelectorAll('.tabs ul li label'); 
////console.log(buttons);

//buttons.forEach((button) => {
//    button.addEventListener('click', () => {
//        console.log("tab clicked");
//    })
//});






const app = new App();
document.body.appendChild(app.el);
if (window.location.hostname === 'localhost') window.app = app;
